import React from 'react';
import StarRatings from 'react-star-ratings';

export const PRIMARY_BLUE = '#135CA9';
/** Фон незаполненных звёзд, когда рейтинга ещё нет */
export const EMPTY_GRAY = '#C4C4C4';
/** Фон незаполненных звёзд, когда рейтинг уже есть */
export const EMPTY_BLUE = '#C4C4C4';

/**
 * Обёртка над react-star-ratings:
 * - разный цвет пустых звёзд при rating=0 и rating>0
 */
export default class StarRating extends React.Component {
    constructor(args) {
        super(args);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        this.clearTitle();
    }

    componentDidUpdate() {
        this.clearTitle();
    }

    clearTitle = () => {
        const root = this.rootRef.current;
        if (!root) {
            return;
        }
        const el = root.querySelector('.star-ratings');
        if (el) {
            el.removeAttribute('title');
        }
    };

    getEmptyColor = () => {
        if (this.props.starEmptyColor) {
            return this.props.starEmptyColor;
        }
        const rating = Number(this.props.rating) || 0;
        return rating > 0 ? EMPTY_BLUE : EMPTY_GRAY;
    };

    render() {
        const {
            rating = 0,
            onChange,
            readOnly = false,
            starRatedColor = PRIMARY_BLUE,
            starHoverColor = PRIMARY_BLUE,
            starDimension = '18px',
            starSpacing = '1px',
            numberOfStars = 5,
            name = 'carrier-rating'
        } = this.props;

        const changeRating = readOnly || !onChange
            ? undefined
            : (newRating) => onChange(newRating);

        return (
            <div
                ref={this.rootRef}
                className="star-rating-wrap"
                onMouseMove={this.clearTitle}
                onMouseLeave={this.clearTitle}
            >
                <StarRatings
                    rating={Number(rating) || 0}
                    starRatedColor={starRatedColor}
                    starEmptyColor={this.getEmptyColor()}
                    starHoverColor={starHoverColor}
                    changeRating={changeRating}
                    numberOfStars={numberOfStars}
                    name={name}
                    starDimension={starDimension}
                    starSpacing={starSpacing}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./App/components/CarrierReview/StarRating.jsx